import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=90228b4c&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90228b4c')) {
      api.createRecord('90228b4c', component.options)
    } else {
      api.reload('90228b4c', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=90228b4c&", function () {
      api.rerender('90228b4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Audience/Bulk/Pages/Index.vue"
export default component.exports